import { graphql } from '@/generated/gql';

export const LOAD_FILTERS_QUERY = graphql(/* GraphQL */ `
  query LoadFilters {
    filters(order_by: { updatedAt: desc }) {
      id
      userId
      name
      queryId
      domain
      isFavorite
    }
  }
`);
